import apiClient from '@/api/client'

export interface AdminUserResponse {
  id: string
  first_name?: string
  last_name?: string
  email: string
  can_manage_admins?: boolean
  remind_password_change_90_days?: boolean
}

export interface CreateAdminPayload {
  email: string
  first_name?: string
  last_name?: string
  password?: string // Optional - backend will generate if not provided
  can_manage_admins?: boolean
}

export const adminsApi = {
  async updatePasswordReminderForAll(enabled: boolean): Promise<{ message: string; updated_count: number; enabled: boolean }> {
    const { data } = await apiClient.put(`/api/v1/users/admins/password-reminder?enabled=${enabled}`)
    return data
  },
  async list(): Promise<AdminUserResponse[]> {
    const { data } = await apiClient.get('/api/v1/users/admins')
    return data
  },
  async create(payload: CreateAdminPayload): Promise<AdminUserResponse> {
    const { data } = await apiClient.post('/api/v1/users/admins', payload)
    return data
  },
  async update(id: string, payload: Partial<AdminUserResponse>): Promise<AdminUserResponse> {
    const { data } = await apiClient.put(`/api/v1/users/${id}`, payload)
    return data
  },
  async remove(id: string): Promise<{ message: string }> {
    const { data } = await apiClient.delete(`/api/v1/users/${id}`)
    return data
  },
}



